import { HoverCard, Text } from '@mantine/core';
import { textOrDash } from '../../../shared/utils/formatText';

interface IHoverCardTextProps {
  value?: string | null;
  dropdownWidth?: number;
  textAlign?: 'left' | 'center' | 'right';
}

export default function HoverCardText(props: IHoverCardTextProps) {
  const { value, dropdownWidth = 320, textAlign = 'left' } = props;
  const displayValue = textOrDash(value);

  if (displayValue === '-') {
    return (
      <Text ta={textAlign} size="sm" truncate="end">
        {displayValue}
      </Text>
    );
  }

  return (
    <HoverCard width={dropdownWidth} shadow="md" position="bottom-start" openDelay={150} closeDelay={100} withArrow>
      <HoverCard.Target>
        <Text ta={textAlign} size="sm" truncate="end" style={{ cursor: 'pointer' }}>
          {displayValue}
        </Text>
      </HoverCard.Target>
      <HoverCard.Dropdown p="sm">
        <Text size="sm" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
          {displayValue}
        </Text>
      </HoverCard.Dropdown>
    </HoverCard>
  );
}
